// extracted by mini-css-extract-plugin
export default {"listContainer":"WishListList_listContainer__zIEJR","wishListItem":"WishListList_wishListItem__njOGS"};